import { render, staticRenderFns } from "./ApmsRegContractSettlement.vue?vue&type=template&id=36fad3d8&scoped=true&"
import script from "./ApmsRegContractSettlement.vue?vue&type=script&lang=js&"
export * from "./ApmsRegContractSettlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fad3d8",
  null
  
)

export default component.exports